import React from 'react'
import Checkbox from './Checkbox'

const ButtonToggle = (props) => {
    return (
        <a
            href='#'
            className={`btn-toggle ${props.active ? 'active' : ''} ${props.className}`}
            style={props.style ? props.style : {}}
            onClick={props.handleClick}
        >
            <Checkbox value={props.active} />
            <span className='title'>{props.title}</span>
        </a>
    )
}

export default ButtonToggle



// WEBPACK FOOTER //
// ./resources/js/elements/ButtonToggle.js